module.exports = __webpack_public_path__ + "static/media/termometro.946ab233.png";